import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { faInfoCircle, faChevronCircleRight, faCheckCircle, faAngleRight} from '@fortawesome/free-solid-svg-icons';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ProjectService } from '../project.service';
import { SharedService } from '../../helper/shared/shared.service';
import { CalculateService } from '../../helper/calculate/calculate.service';
import { UserInfoService } from '../../user-info/user-info.service';
import { createPopper } from '@popperjs/core';
import { ProjectComponent } from '../project.component';
import { parseHostBindings } from '@angular/compiler';
import { Router  } from '@angular/router'; //Modified by PP(2023-10-24): Check for timeout of logincode

@Component({
  selector: 'app-astm-result',
  templateUrl: './astm-result.component.html',
  styleUrls: ['./astm-result.component.scss']
})
export class AstmResultComponent implements OnInit {
  @Output() nextStep = new EventEmitter<String>();
  faAngleRight = faAngleRight;
  faInfoCircle = faInfoCircle;
  faCheckCircle = faCheckCircle;
  faChevronCircleRight = faChevronCircleRight;

  selected = 'Snapshot';
  state = 1;
  NumberFormat = '';
  AllDDLList : any;
  UnitsFromUserData : any;
  totalAirVolume;
  airVolumeUnit: any;
  airVolumeUnitm3h = 'm³';
  airVolumeUnitft3 = 'ft³';
  weightUnit = '';
  concResultDisplay = '';
  atmPressureDisplay = '';
  vapourPressureDisplay = '';
  vapourPressuremmHg = '';
  molecularWeightDisplay1 = "";
  molecularWeightDisplay2 = "";
  molecularWeightDisplay3 = "";
  projectInfo:any = {};
  astmParams:any = {};
  astmSolutions:any = {};
  contamination: any;
  solutions: any = [];
  results: any = [];
  astmGasInfo: any;
  astmSolInfo: any = [];
  selectedAstmResult: any = [];
  arrConcfor2ndUnit : any=[];
  arrConcforMainUnit : any=[];
  snapshotInfo = false;
  comparisonInfo = false;
  snapshotmediaconsumptionInfo = false;
  mediaconsumptionInfo = false;

  loading:boolean; //Modified by PS(2023-03-27): MCCLD 2023-ASTM Result page: add loading-START

  constructor(
    private toastr: ToastrService,
    public projectService: ProjectService,
    private route: ActivatedRoute,
    private sharedService: SharedService,
    private calculateService: CalculateService,
    private userInfoService: UserInfoService,
    public ProjectComponent: ProjectComponent,
    private router : Router //Modified by PP(2023-10-24): Check for timeout of logincode
  ) { }

  ngOnInit(): void {
    this.loading = true; //Modified by PS(2023-03-27): MCCLD 2023-ASTM Result page: add loading-START
    this.selected = "Snapshot";
  
    this.initiateData();
    this.getSolutions();
  }

  ngAfterViewInit() {
    this.setPoppers();
  }

  selSection(data:any) {
    this.selected = data;
    var x = document.getElementById('divsnapshot');
    switch(this.selected){
      case 'Snapshot':
          x.style.display='flex';
          break;
      case 'Comparison':
          x.style.display='none';
          break;
    }
  }

  setState(selectedSolId:any) {
    this.state = selectedSolId;
    this.astmGasInfo = this.projectService.projectdetails.contamination.gasDetails[selectedSolId-1];
    this.astmSolInfo = this.projectService.projectdetails.solutions[selectedSolId-1];
    this.selectedAstmResult = this.projectService.projectdetails.results.solutionsResults[selectedSolId-1].astmResults;
    this.totalAirVolume = this.astmParams.totalAirVolume;

    //Modified by PP(2023-06-19) : Round up Concentration for Results display in ASTM - START
    // let inputConcValue = this.sharedService.convertLocaletoNumber(this.astmGasInfo.concentrationValue,this.NumberFormat);
    // if (this.projectService.projectdetails.projectInfo.concUnit === this.sharedService.ConcencDesc_ppb) {
    //   this.concResultDisplay = this.astmGasInfo.concentrationValue + " " + this.sharedService.ConcencDesc_ppb;
    //   this.concResultDisplay = this.concResultDisplay + " / " + this.arrConcfor2ndUnit[selectedSolId-1];
    // }else {
    //   this.concResultDisplay = this.astmGasInfo.concentrationValue + " " + this.sharedService.ConcencDesc_mgm3;
    //   this.concResultDisplay = this.concResultDisplay + " / " + this.arrConcfor2ndUnit[selectedSolId-1];
    // }
    let ConcValToNum = this.sharedService.convertLocaletoNumber(this.astmGasInfo.concentrationValue,this.NumberFormat);
    let RoundedConcVal = this.sharedService.formatValue(ConcValToNum.toFixed(3), false); //Modified by PP(2023-10-19) : Christian wants 3 decimal eg 0,035 mgm3
    let AltConcValToNum = this.sharedService.convertLocaletoNumber(this.arrConcfor2ndUnit[selectedSolId-1],this.NumberFormat);
    let RoundedAltConcVal = this.sharedService.formatValue(AltConcValToNum.toFixed(0), false);
    if (this.projectService.projectdetails.projectInfo.concUnit === this.sharedService.ConcencDesc_ppb) {
      this.concResultDisplay = RoundedConcVal + " " + this.sharedService.ConcencDesc_ppb;
      this.concResultDisplay = this.concResultDisplay + " / " + RoundedAltConcVal + this.sharedService.ConcencDesc_mgm3;
    } else {
      this.concResultDisplay = RoundedConcVal + " " + this.sharedService.ConcencDesc_mgm3;
      this.concResultDisplay = this.concResultDisplay + " / " + RoundedAltConcVal + this.sharedService.ConcencDesc_ppb;
    }
    //Modified by PP(2023-06-19) : Round up Concentration for Results display in ASTM - END

    this.atmPressureDisplay = this.selectedAstmResult.atmPressure + " ";
    if (this.projectService.projectdetails.projectInfo.unitId === 1) {
      this.atmPressureDisplay = this.atmPressureDisplay + this.UnitsFromUserData.AtmPa;
    }else {
      this.atmPressureDisplay = this.atmPressureDisplay + this.UnitsFromUserData.AtmPa;
    }

    this.vapourPressureDisplay = this.selectedAstmResult.vapourPressure + " " + this.UnitsFromUserData.VapourPa;
    this.vapourPressuremmHg = this.selectedAstmResult.vapourPressureMMHg + " mm hg";
  }

  getSolutions () {
  if(this.route.snapshot.url[0].path.toLowerCase() == 'projectedit' && this.sharedService.blnLoadFromRecord === true) {
    this.projectService.listData = this.sharedService.listData;
      if (this.sharedService.blnLoadFromRecord == true) {
        let data=this.projectService.getProjectStructure(this.sharedService.loadFromDatabase);               
        if (data !== undefined || data !== "") {
          this.initiateData();
        //   this.sharedService.blnLoadFromRecord = true;                 
        }
        let solres = this.projectService.getAstmSolResultStructure(this.sharedService.loadFromDatabase.Params.MCCLDResults);
        this.initiateValuesAfterCalc(solres);    
        this.sharedService.blnLoadFromRecord = false;
      } else {

      }     
    } else if(this.route.snapshot.url[0].path.toLowerCase() == 'importxml' && this.sharedService.projectNotCalc == false) {
      if (this.sharedService.LoadingXML == true) {
        this.projectService.listData = this.sharedService.listData;     
        let data=this.projectService.getProjectStructure(this.sharedService.importXMLData);               
        if (data !== undefined || data !== "") {
          this.initiateData();
        //   this.sharedService.blnLoadFromRecord = true;                 
        }

        let solres = this.projectService.getAstmSolResultStructure(this.sharedService.importXMLData.Params.MCCLDResults);
  
        // convert results to selected unit Id at backend service
        this.initiateValuesAfterCalc(solres);
        this.sharedService.LoadingXML = false;
      } else {
        if (this.astmSolutions.length > 0) {
          for (let i=0; i< this.astmSolutions.length; i++) {
            switch (i){
              case 0:
                this.molecularWeightDisplay1 = this.astmParams.gasDetails[i].moreInformation.molecularWeight + " " + "g/mol";
                break;
              case 1:
                this.molecularWeightDisplay2 = this.astmParams.gasDetails[i].moreInformation.molecularWeight + " " + "g/mol";
                break;
              case 2:
                this.molecularWeightDisplay3 = this.astmParams.gasDetails[i].moreInformation.molecularWeight + " " + "g/mol";
                break;
            }
          }
          this.triggerCalculation();
        }
      }

    } else if (this.projectService.projectdetails.solutions && this.sharedService.blnLoadFromRecord === false) { // New Project
      if (this.astmSolutions.length > 0) {
        for (let i=0; i< this.astmSolutions.length; i++) {
          switch (i){
            case 0:
              this.molecularWeightDisplay1 = this.astmParams.gasDetails[i].moreInformation.molecularWeight + " " + "g/mol";
              break;
            case 1:
              this.molecularWeightDisplay2 = this.astmParams.gasDetails[i].moreInformation.molecularWeight + " " + "g/mol";
              break;
            case 2:
              this.molecularWeightDisplay3 = this.astmParams.gasDetails[i].moreInformation.molecularWeight + " " + "g/mol";
              break;
          }
        }
        this.triggerCalculation();
      }
    }
  }

  /*getSolutionsORI () {
    if(this.route.snapshot.url[0].path.toLowerCase() == 'projectedit' && this.sharedService.blnLoadFromRecord === true) {
        this.projectService.listData = this.sharedService.listData;
        console.log("PS20230321 Check: => load selected record -START=> "   + new Date());
        this.projectService.callLoadProjectApi(this.sharedService.ProjectToEdit.id,true).subscribe(
          res =>{
            console.log("PS20230321 Check: => load selected record -END=> "   + new Date());
            console.log(res);
            if (res == null) {
              let msg = "Failed to load saved project! Please try again.";
              this.toastr.error(msg, "");
              //this.loading = false;
            } else {
              let data=this.projectService.getProjectStructure(res); 
  
              if (res.Params.ExportType == 'Complete') {
                this.sharedService.projectNotCalc = false;
              } else {
                this.sharedService.projectNotCalc = true;
              }
  
              if (this.sharedService.projectNotCalc) {
                this.ProjectComponent.prevStep();
              }
              
              let results={};
              results = this.projectService.getSolResultsStructure(res.Params.MCCLDResults);
              this.projectService.projectdetails.results=results;
  
              if (data !== undefined || data !== "") {
                this.initiateData(); 
                //this.sharedService.blnLoadFromRecord = false; //initially was false              
              }
  
              if(data.results.solutionsResults !== undefined){           
                //this.getViewinReport();
              }
              this.sharedService.blnLoadFromRecord = false;
            }
          },
          err =>{
            //this.loading = false;
            this.toastr.error("Failed to load saved project! Please try again.", "");
          }
        );
      } else if(this.route.snapshot.url[0].path.toLowerCase() == 'importxml' && this.sharedService.projectNotCalc == false) {
        if (this.sharedService.LoadingXML == true) {
          this.projectService.listData = this.sharedService.listData;     
          let data=this.projectService.getProjectStructure(this.sharedService.importXMLData);               
          if (data !== undefined || data !== "") {
            this.initiateData();
          //   this.sharedService.blnLoadFromRecord = true;                 
          }
  
          let solres = this.projectService.getAstmSolResultStructure(this.sharedService.importXMLData.Params.MCCLDResults);
          //this.projectService.projectdetails.results=solres;
  
          // convert results to selected unit Id at backend service
          this.initiateValuesAfterCalc(solres);
  
          //this.getViewinReport();
          this.sharedService.LoadingXML = false;
        } else {
          if (this.astmSolutions.length > 0) {
            for (let i=0; i< this.astmSolutions.length-1; i++) {
              switch (i){
                case 0:
                  this.molecularWeightDisplay1 = this.astmParams.gasDetails[i].moreInformation.molecularWeight + " " + "g/mol";
                  break;
                case 1:
                  this.molecularWeightDisplay2 = this.astmParams.gasDetails[i].moreInformation.molecularWeight + " " + "g/mol";
                  break;
                case 2:
                  this.molecularWeightDisplay3 = this.astmParams.gasDetails[i].moreInformation.molecularWeight + " " + "g/mol";
                  break;
              }
            }
            this.triggerCalculation();
          }
        }
  
      } else if (this.projectService.projectdetails.solutions && this.sharedService.blnLoadFromRecord === false) { // New Project
        if (this.astmSolutions.length > 0) {
          for (let i=0; i< this.astmSolutions.length-1; i++) {
            switch (i){
              case 0:
                this.molecularWeightDisplay1 = this.astmParams.gasDetails[i].moreInformation.molecularWeight + " " + "g/mol";
                break;
              case 1:
                this.molecularWeightDisplay2 = this.astmParams.gasDetails[i].moreInformation.molecularWeight + " " + "g/mol";
                break;
              case 2:
                this.molecularWeightDisplay3 = this.astmParams.gasDetails[i].moreInformation.molecularWeight + " " + "g/mol";
                break;
            }
          }
          this.triggerCalculation();
        }
      }
  }

  getSolutionsORI2 () {
    if (this.astmSolutions.length > 0) {
      for (let i=0; i< this.astmSolutions.length-1; i++) {
        switch (i){
          case 0:
            this.molecularWeightDisplay1 = this.astmParams.gasDetails[i].moreInformation.molecularWeight + " " + "g/mol";
            break;
          case 1:
            this.molecularWeightDisplay2 = this.astmParams.gasDetails[i].moreInformation.molecularWeight + " " + "g/mol";
            break;
          case 2:
            this.molecularWeightDisplay3 = this.astmParams.gasDetails[i].moreInformation.molecularWeight + " " + "g/mol";
            break;
        }
      }
      this.triggerCalculation();
    }
  }*/

  triggerCalculation() {
    //Modified by PS(2023-03-27): MCCLD 2023-ASTM Result page: add loading-START
    if(this.projectService.generateResultRequired(true)) {
      this.sharedService.ServerData = this.sharedService.CompileDataForCalculation(this.projectService.projectdetails, 0);
      this.sharedService.CountTotalSeqForUploadingParams(this.sharedService.ServerData, "UPLOAD MCCLD PARAMS TO SERVER");
      this.PreparedToUploadParams();
    }else{
      //why pass undefined????? this.initiateValuesAfterCalc(undefined);
      this.initiateValuesAfterCalc(this.projectService.projectdetails.results.solutionsResults);
    }

    //Modified by PS(2023-03-27): MCCLD 2023-ASTM Result page: add loading-END

  }

  PreparedToUploadParams() {
    let dataToUpload = this.sharedService.generateStr();
    console.log("PS20230321 Check: => UploadServerData2TempStringStorage - START=> "   + new Date());   
    this.projectService.UploadServerData2TempStringStorage(dataToUpload).subscribe(
      res => {
        console.log("PS20230321 Check: => UploadServerData2TempStringStorage - END=> "   + new Date());   
        if (res) {
          this.sharedService.TempStringStorageTotalPass = this.sharedService.TempStringStorageTotalPass +1;
          this.sharedService.ServerDataReady = true;
          this.sharedService.UploadingEntry = false;
          if (this.sharedService.TempStringStorageTotalPass+this.sharedService.TempStringStorageTotalFail!==this.sharedService.TempStringStorageTotalSeq){
            this.sharedService.TempStringStorageCurrentSeq = this.sharedService.TempStringStorageCurrentSeq + 1;
            this.PreparedToUploadParams();
          } else{
            if (this.sharedService.TempStringStorageTotalPass === this.sharedService.TempStringStorageTotalSeq){
              console.log("PS20230321 Check: => Perform ASTM Calculation -START=> "   + new Date());
              this.projectService.PerformAstmCalculation().subscribe(data => {
                console.log("PS20230321 Check: => Perform ASTM Calculation -END=> "   + new Date());
                let resultReady = false;

                //Modified by PP(2023-10-24): Check for timeout of logincode - START
                if (data!==null) {
                  if (data!==undefined) {

                    this.userInfoService.updateUserApplicationUsage(this.sharedService.token, 'SUCCESS_CALCULATION').subscribe(result => {                       
                      if (result) {}
                    });
                    
                    if (data.SolutionResults.length > 0) {
                      let resultMsg = "";
                      for (let i=0 ; i<data.SolutionResults.length; i++) {
                        resultMsg = data.SolutionResults[i].ASTMResults.Msg.Msg;
                        if (resultMsg === "success") {
                          resultReady = true;
                          break;
                        }
                      }
                      if (resultReady === true) {
                        let solres = this.projectService.getAstmSolResultStructure(data);
    
                        // convert results to selected unit Id at backend service
                        this.initiateValuesAfterCalc(solres);               
                      }
                    }
                  } else {
                    this.toastr.error("Unable to calculate result. Please try again.", "Error");
                  }
                } else {
                  this.sharedService.redirectToLoginPage();
                  // this.userInfoService.userData.UserId = 0;
                  // this.toastr.error('Session time out. Please login again.', '');
                  // this.router.navigate(["login"]);
                }
                //Modified by PP(2023-10-24): Check for timeout of logincode - END      
              });
            }
          }
        }
      });
  }

  setPoppers() {
    let snapshotInfoBtn = document.getElementById('SnapshotInfoBtn');
    let snapshotInfoToolTip = document.getElementById('divSnapshotInfo');

    let comparisonInfoBtn = document.getElementById('ComparisonInfoBtn');
    let comparisonToolTip = document.getElementById('divComparisonInfo');

    let snapshotmediaConsumptionInfoBtn = document.getElementById('SnapShotMediaConsumpInfoBtn');
    let snapshotmediaConsumptionToolTip = document.getElementById('divSnapShotMediaConsumpInfo');

    this.createPopBottom(snapshotInfoBtn, snapshotInfoToolTip);
    this.createPopBottom(comparisonInfoBtn, comparisonToolTip);
    this.createPopMediaConsumpSnapShot(snapshotmediaConsumptionInfoBtn, snapshotmediaConsumptionToolTip);

  }

  setMediaConsumptionMediaPopper() {
    let mediaConsumptionInfoBtn = document.getElementById('MediaConsumpInfoBtn');
    let mediaConsumptionToolTip = document.getElementById('divMediaConsumpInfo');
    this.createPop(mediaConsumptionInfoBtn, mediaConsumptionToolTip);
  }

  createPopMediaConsumpSnapShot(ref:any, popper:any ) {
    createPopper(ref, popper, {
      placement: 'top-start',
      modifiers: [
         {
           name: "offset",
           options: {
             offset: [-600, 8],
           },
         },
      ],
    });
  }

  createPop(ref:any, popper:any ) {
    createPopper(ref, popper, {
      placement: 'top-start',
      modifiers: [
         {
           name: "offset",
           options: {
             offset: [6, 10],
           },
         },
      ],
    });
  }

  createPopBottom(ref:any, popper:any)  {
    createPopper(ref, popper, {
      placement: 'bottom-start',
      modifiers: [
         {
           name: "offset",
           options: {
             offset: [-70, 8],
           },
         },
      ],
    });
  }

  showHideInfoToggle (WhichInfo:string) {
    let divsnapshotInfo = document.getElementById('divSnapshotInfo');
    let divcomparisonInfo = document.getElementById('divComparisonInfo');
    let divSnapShotMediaConsumpInfo = document.getElementById('divSnapShotMediaConsumpInfo');
    let divMediaConsumpInfo = document.getElementById('divMediaConsumpInfo');
    switch (WhichInfo) {
      case 'SnapshotInfo':
        if (this.snapshotInfo) {
          divsnapshotInfo.removeAttribute("data-show");
          this.snapshotInfo = false;
        }else {
          divsnapshotInfo.setAttribute("data-show", "");
          this.snapshotInfo = true;
        }
        break;
      case 'ComparisonInfo':
        if (this.comparisonInfo) {
          divcomparisonInfo.removeAttribute("data-show");
          this.comparisonInfo = false;
        }else {
          divcomparisonInfo.setAttribute("data-show", "");
          this.comparisonInfo = true;
        }
        break;
      case 'SnapShotMediaConsumptionInfo':
        if (this.snapshotmediaconsumptionInfo) {
          divSnapShotMediaConsumpInfo.removeAttribute("data-show");
          this.snapshotmediaconsumptionInfo = false;
        }else {
          divSnapShotMediaConsumpInfo.setAttribute("data-show", "");
          this.snapshotmediaconsumptionInfo = true;
        }
        break;
      case 'MediaConsumptionInfo':
        this.setMediaConsumptionMediaPopper();
        if (this.mediaconsumptionInfo) {
          divMediaConsumpInfo.removeAttribute("data-show");
          this.mediaconsumptionInfo = false;
        }else {
          divMediaConsumpInfo.setAttribute("data-show", "");
          this.mediaconsumptionInfo = true;
        }
        break;
    }
  }

  next(){
    this.nextStep.emit();
  }

  initiateData() {
    this.NumberFormat = this.userInfoService.userData.currentLocale;
    this.AllDDLList = this.sharedService.listData;

    if (this.userInfoService.userData != null || this.userInfoService.userData != undefined) {
      if (this.userInfoService.userData.UserUnitId === this.sharedService.unitId_SI) {
        this.UnitsFromUserData = this.AllDDLList.UnitInfoClass.UnitInfo_SI;
        this.weightUnit = 'kg';
      } else {
        this.UnitsFromUserData = this.AllDDLList.UnitInfoClass.UnitInfo_US;
        this.weightUnit = 'lbs';
      }
    } else {
      if (this.projectService.projectdetails.projectInfo != null || this.projectService.projectdetails.projectInfo != undefined) {
        if (this.projectService.projectdetails.projectInfo.unitId === this.sharedService.unitId_SI) {
          this.UnitsFromUserData = this.AllDDLList.UnitInfoClass.UnitInfo_SI;
          this.weightUnit = 'kg';
        } else {          
          this.UnitsFromUserData = this.AllDDLList.UnitInfoClass.UnitInfo_US;
          this.weightUnit = 'lbs'; 
        }
      }
    }

    // if (this.projectService.projectdetails.projectInfo != null || this.projectService.projectdetails.projectInfo != undefined) {
    //   this.projectInfo = this.projectService.projectdetails.projectInfo;
    //   if (this.projectService.projectdetails.projectInfo.unitId === this.sharedService.unitId_SI) {
    //     this.UnitsFromUserData = this.AllDDLList.UnitInfoClass.UnitInfo_SI;
    //     this.weightUnit = 'kg';
    //   } else {
    //     this.UnitsFromUserData = this.AllDDLList.UnitInfoClass.UnitInfo_US;
    //     this.weightUnit = 'lbs';
    //   }
    // }
    
    if (this.projectService.projectdetails.contamination != null || this.projectService.projectdetails.contamination != undefined) {
      this.astmParams = this.projectService.projectdetails.contamination;
    }
    
    if (this.projectService.projectdetails.solutions != null || this.projectService.projectdetails.solutions != undefined) {
      this.astmSolutions= this.projectService.projectdetails.solutions;
    }    
  }

  initiateValuesAfterCalc(solres:any) {
    //Modified by PS(2023-03-27): MCCLD 2023-ASTM Result page: add loading-START
    /*if (Object.keys(solres).length !==0) {
      this.projectService.projectdetails.results.solutionsResults = solres;
      this.results = this.projectService.projectdetails.results.solutionsResults;
      // to get concentration value for 2nd unit, store in arrConcfor2ndUnit
       for (let i=0; i<this.astmParams.gasDetails.length; i++) {
        let gasdet = this.astmParams.gasDetails[i];
        let inputConcValue = 0;
        if (this.projectService.projectdetails.projectInfo.concUnit === this.sharedService.ConcencDesc_ppb) {
          inputConcValue = this.sharedService.convertLocaletoNumber(gasdet.concentrationValue,this.NumberFormat);
          let calcMgm3ConcVal = this.calculateService.CalculateConcentration(inputConcValue, this.sharedService.ConcencDesc_mgm3, this.projectService.projectdetails.projectInfo.unitId, this.NumberFormat, this.astmParams.temperature, this.sharedService.convertLocaletoNumber(gasdet.moreInformation.molecularWeight, this.NumberFormat));
          let concMgm3 = this.sharedService.formatValue(calcMgm3ConcVal,false) + " " + this.sharedService.ConcencDesc_mgm3;
          this.arrConcfor2ndUnit.push(concMgm3);
        }else{
          inputConcValue = this.sharedService.convertLocaletoNumber(gasdet.concentrationValue,this.NumberFormat);
          let calcPbbConcVal = this.calculateService.CalculateConcentration(inputConcValue, this.sharedService.ConcencDesc_ppb, this.projectService.projectdetails.projectInfo.unitId, this.NumberFormat, this.astmParams.temperature, this.sharedService.convertLocaletoNumber(gasdet.moreInformation.molecularWeight, this.NumberFormat));
          let concPbb = this.sharedService.formatValue(calcPbbConcVal,false) + " " + this.sharedService.ConcencDesc_ppb;
          this.arrConcfor2ndUnit.push(concPbb);
        }
      }
      this.updateAirVolumeUnit();
      this.calcTotAirVolume();
      this.setState(this.state);
    }*/
    if(solres!==undefined){
      if (Object.keys(solres).length !==0) {
        if (this.projectService.projectdetails.results == undefined) {
          let tmpResults = this.projectService.getResultsEmptyValueStructure();
          this.projectService.projectdetails.results = tmpResults;
        }
        
        this.projectService.projectdetails.results.solutionsResults = solres;
        this.results = this.projectService.projectdetails.results.solutionsResults;
        // to get concentration value for 2nd unit, store in arrConcfor2ndUnit
         for (let i=0; i<this.astmParams.gasDetails.length; i++) {
          let gasdet = this.astmParams.gasDetails[i];
          let inputConcValue = 0;
          if (this.projectService.projectdetails.projectInfo.concUnit === this.sharedService.ConcencDesc_ppb) {
            inputConcValue = this.sharedService.convertLocaletoNumber(gasdet.concentrationValue,this.NumberFormat);
            let calcMgm3ConcVal = this.calculateService.CalculateConcentration(inputConcValue, this.sharedService.ConcencDesc_mgm3, this.projectService.projectdetails.projectInfo.unitId, this.NumberFormat, this.astmParams.temperature, this.sharedService.convertLocaletoNumber(gasdet.moreInformation.molecularWeight, this.NumberFormat));
            let concMgm3 = this.sharedService.formatValue(calcMgm3ConcVal,false) + " " + this.sharedService.ConcencDesc_mgm3;
            this.arrConcfor2ndUnit.push(concMgm3);
            var mainConcValueRound = inputConcValue.toFixed(3); //Modified by PP(2023-10-19) : Christian wants 3 decimal eg 0,035 mgm3
            var mainConcValueInString = this.sharedService.formatValue(mainConcValueRound,false) + " " + this.sharedService.ConcencDesc_ppb;
            this.arrConcforMainUnit.push(mainConcValueInString);
          }else{
            inputConcValue = this.sharedService.convertLocaletoNumber(gasdet.concentrationValue,this.NumberFormat);
            let calcPbbConcVal = this.calculateService.CalculateConcentration(inputConcValue, this.sharedService.ConcencDesc_ppb, this.projectService.projectdetails.projectInfo.unitId, this.NumberFormat, this.astmParams.temperature, this.sharedService.convertLocaletoNumber(gasdet.moreInformation.molecularWeight, this.NumberFormat));
            let concPbb = this.sharedService.formatValue(calcPbbConcVal.toFixed(0),false) + " " + this.sharedService.ConcencDesc_ppb;
            this.arrConcfor2ndUnit.push(concPbb);
            var mainConcValueRound = inputConcValue.toFixed(3); //Modified by PP(2023-10-19) : Christian wants 3 decimal eg 0,035 mgm3
            var mainConcValueInString = this.sharedService.formatValue(mainConcValueRound,false) + " " + this.sharedService.ConcencDesc_mgm3;
            this.arrConcforMainUnit.push(mainConcValueInString);
          }
        }
      }
    }
    this.updateAirVolumeUnit();
    this.calcTotAirVolume();
    this.setState(this.state);
    this.projectService.projectDetails_successResult = this.projectService.convertProjectEntriesToJson(this.projectService.projectdetails);
    this.loading=false; 
    //Modified by PS(2023-03-27): MCCLD 2023-ASTM Result page: add loading-END
  }

  updateAirVolumeUnit() {
    if (this.userInfoService.userData != null || this.userInfoService.userData != undefined) {
      if (this.userInfoService.userData.UserUnitId === this.sharedService.unitId_SI) {
        this.airVolumeUnit = this.airVolumeUnitm3h;
      } else { //US
        this.airVolumeUnit = this.airVolumeUnitft3;
      }
    } else {
      if (this.projectService.projectdetails.projectInfo != null || this.projectService.projectdetails.projectInfo != undefined) {
        if (this.projectService.projectdetails.projectInfo.unitId === this.sharedService.unitId_SI) {
          this.airVolumeUnit = this.airVolumeUnitm3h;
        } else { //US
          this.airVolumeUnit = this.airVolumeUnitft3;
        }
      }
    }
  }

  calcTotAirVolume() {
    let tothours = this.sharedService.convertLocaletoNumber(this.astmParams.runningTime,this.NumberFormat);
    let totairflow = this.sharedService.convertLocaletoNumber(this.astmParams.airflow,this.NumberFormat);
    let airflowUnit = this.astmParams.airflowUnit ;
    let airflowm3h = totairflow;

    //Modified by PP(2023-11-10) : Bugs. Cannot only just convert from CFM - START
    // if (airflowUnit === "CFM") {
    //   airflowm3h =  this.calculateService.ConvertAirFlow(totairflow, 'CFM', 'm³/h');
    // }
    if (airflowUnit != 'm³/h') {
      airflowm3h =  this.calculateService.ConvertAirFlow(totairflow, airflowUnit, 'm³/h');
    }
    //Modified by PP(2023-11-10) : Bugs. Cannot only just convert from CFM - END

    let calcairvolumevalue = this.calculateService.CalculateTotalAirVolume(tothours,airflowm3h);
    let airvolumevalue = calcairvolumevalue ;

    //Modified by PP(2023-11-10) : Bugs. Cannot only just convert from CFM - START
    // if (airflowUnit === "CFM") {
    //   airvolumevalue =  this.calculateService.ConvertTotalAirVol_US(calcairvolumevalue);
    // }
    if (this.userInfoService.userData.UserUnitId === this.sharedService.unitId_US) {
      airvolumevalue =  this.calculateService.ConvertTotalAirVol_US(calcairvolumevalue);
    }
    //Modified by PP(2023-11-10) : Bugs. Cannot only just convert from CFMD - END

    //this.astmParams.runningTime = this.sharedService.formatValue(tothours, true);
    //this.astmParams.airflow = this.sharedService.formatValue(totairflow, true);
    this.totalAirVolume = this.sharedService.formatValue(airvolumevalue, false) + " " + this.airVolumeUnit;
    this.astmParams.totalAirVolume = this.totalAirVolume;
  }

}
